var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHrmkaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1797_31033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3605 7.68382C22.4026 2.57365 18.1643 -0.507796 15.8929 0.800935C13.6214 2.10967 14.1763 7.31263 17.1345 12.4196C20.0927 17.5298 24.3307 20.6112 26.6021 19.3026C28.8735 17.9937 28.3187 12.7908 25.3605 7.68382Z",
    fill: "#05A9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63945 7.68382C5.59751 2.57365 9.83563 -0.507796 12.1071 0.800935C14.3785 2.10967 13.8235 7.31263 10.8655 12.4196C7.90745 17.5298 3.66933 20.6112 1.39787 19.3026C-0.873598 17.9937 -0.318575 12.7908 2.63945 7.68382Z",
    fill: "#6D31C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 27.3791C19.9127 27.3791 24.709 25.2577 24.709 22.6403C24.709 20.0228 19.9159 17.9011 13.9998 17.9011C8.0838 17.9011 3.29062 20.0228 3.29062 22.6403C3.29062 25.2577 8.0838 27.3791 13.9998 27.3791Z",
    fill: "#6D31C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1797_31033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrmkaLogo);
export default __webpack_public_path__ + "static/media/hrmka-logo.db1c62d7895be34fe1e6946dd6e2bfda.svg";
export { ForwardRef as ReactComponent };